(function() {


    document.addEventListener('DOMContentLoaded', function() {

        const currentUrl = new URL(window.location.href);
        let utmCampaign = currentUrl.searchParams.get('utm_campaign') ?? '';                

        const formData = {
            action: 'calculate_contact_phone_controller',
            utmCampaign: utmCampaign
        } 
        const queryString = new URLSearchParams(formData).toString();
        fetch(wpajax.ajaxurl + '?' + queryString, {
            method: 'GET'
        })
        .then(response => response.json())
        .then(response => { 
            if ( response.success ) {
                document.querySelectorAll('.top-landing-block').forEach(block => {
                    const contactButton = block.querySelector('.top-landing-btn-contact');
                    const phoneWithPrefix = window.AseguraGoConstants.PHONE_PREFIX + response.data.phoneFormatted;
                    contactButton.href = 'tel:' + phoneWithPrefix;
                    contactButton.setAttribute('data-phone', phoneWithPrefix);
                    contactButton.querySelector('span').textContent = response.data.phone;
                    
                    if ( response.data.enabled ) {
                        block.querySelector('.top-landing-block-wrapper').classList.add('contact-buton-active');
                    }

                });
            }
        });
    });




    document.querySelectorAll('.top-landing-block').forEach(block => {

        const aseguraGoAnalytics = new window.AseguraGoAnalytics();

        const contactButton = block.querySelector('.top-landing-btn-contact');

        contactButton.addEventListener('click', () => {
            
            const brand = contactButton.getAttribute('data-brand');
            const reference = contactButton.getAttribute('data-reference');
            const phone = contactButton.getAttribute('data-phone');

            const eventDetail = {     
                typeEventData: 'call',
                phone: phone,
                pageUrl: window.location.href,
                utmSource: aseguraGoAnalytics.getUtmSource(),
                utmMedium: aseguraGoAnalytics.getUtmMedium(),
                utmCampaign: aseguraGoAnalytics.getUtmCampaign(),
                utmContent: aseguraGoAnalytics.getUtmContent(),
                utmTerm: aseguraGoAnalytics.getUtmTerm(),
                leadId: aseguraGoAnalytics.generateLeadId(),
                brand: brand,
                reference: reference,
            }

            document.dispatchEvent(new CustomEvent(window.AseguraGoConstants.ASEGURAGO_CONTACT_PHONE_EVENT, {
                detail: eventDetail
            }));    
            
            document.dispatchEvent(new CustomEvent(window.MetricsManagerUserDataConstants.METRICS_USERDATA_EVENT_SEND_DATALAYER, {
                detail: eventDetail
            }));    
        });

        

    });

})();